import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import CrossIcon from "@assets/icons/CrossIcon";
import RiskErrorIcon from "@assets/icons/RiskErrorIcon";
import { ReactComponent as ToastSuccessIcon } from "@assets/images/icons/toast-success.svg";
import { useTranslation } from "@helpers/translate";
import { ALERT } from "../../../../constants";
import "@components/pages/Futures/components/FuturesNotification/index.sass";
import { useSwipeDismiss } from "@components/pages/Futures/components/FuturesNotification/useSwipeDismiss";

const ALERT_DURATION = 3000;

export const MyAlert = () => {
  const { type, hidden, message, title } = useSelector((state) => state.alert);
  const dispatch = useDispatch();
  const { __ } = useTranslation();
  const timerRef = useRef(null);

  const hide = () => dispatch({ type: ALERT.ALERT_HIDE });

  useEffect(() => {
    if (hidden || !type) return;

    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(hide, ALERT_DURATION);

    return () => clearTimeout(timerRef.current);
  }, [hidden, type, message]);

  const { style: swipeStyle, handlers: swipeHandlers } = useSwipeDismiss(hide);

  if (!type || hidden) return null;

  const resolvedTitle =
    title ??
    (type === "error" ? __("common.error_occurred") : __("common.successful"));

  return createPortal(
    <div className="futures-toasts is-active" style={{ "--futures-toasts-count": 1 }}>
      <div
        className="futures-toast"
        style={{ "--futures-toast-depth": 0, ...swipeStyle }}
        role="alert"
        {...swipeHandlers}
      >
        {type === "error" ? (
          <RiskErrorIcon />
        ) : (
          <ToastSuccessIcon className="futures-toast__icon" />
        )}

        <div className="futures-toast__body">
          <h3 className="futures-toast__title">{resolvedTitle}</h3>
          <p className="futures-toast__text">{message}</p>
        </div>

        <button
          type="button"
          className="futures-toast__close"
          onClick={hide}
          aria-label="Close"
        >
          <CrossIcon size={16} />
        </button>

        <span
          className="futures-toast__progress"
          style={{ animationDuration: `${ALERT_DURATION}ms` }}
          onAnimationEnd={hide}
        />
      </div>
    </div>,
    document.body,
  );
};

export default MyAlert;
